<template>
  <v-col cols="12" style="position: relative">
    <v-textarea
      v-model="text"
      :rows="rows"
      outlined
      dense
      :required="required"
      :readonly="readonly"
      :rules="rules"
      :label="label"
      :data-cy="`${stepLabel}-editField`"
      :class="required ? 'required-asterisk' : ''"
      @input="$emit('change', text)"
    />
    <v-btn
      class="button-help"
      style="position: absolute; top: 10px; right: 10px"
      icon
      small
      :disabled="readonly"
      @click="$emit('openEditor')"
    >
      <v-icon small color="info">mdi-pencil</v-icon>
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'TextInputWithEditorButton',
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default() {
        return this.$lang.labels.query
      }
    },
    stepLabel: {
      type: String,
      default: 'step'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      text: this.defaultValue
    }
  },
  watch: {
    defaultValue: {
      handler(val) {
        this.text = val
      }
    }
  },
  beforeDestroy() {
    this.$set(this, 'text', null)
  }
}
</script>
